import { FC } from 'react';
import { RouteProps as ReactRouterRouteProps } from 'react-router-dom';
import { Filters } from './filter';

export class ListResult<T> {
  constructor(public readonly items: Array<T>, public readonly total: number) {}
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type ResultFailure = any | null;

export interface ListResultState<T> {
  data: ListResult<T> | null;
  loading: boolean;
  error: ResultFailure;
  filter: Filters;
}

export interface ResultState<T> {
  data: T;
  loading: boolean;
  error: ResultFailure;
}

export enum SceneType {
  VERIFICATION = 'verification',
  INVITATION = 'invitation',
  RESET_PASSWORD = 'reset-password',
  FORGOT_PASSWORD = 'forgot-password',
}

export interface EmailVerificationState {
  verifiedEmail: string;
  loading: boolean;
  isNextPushed?: boolean;
  scene?: SceneType | null;
  passwordSubmitLoading: boolean;
  passwordSubmitError?: string | null;
}

export type IdType = number;

export interface StringIndexed {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [key: string]: any;
}

export interface BaseEntity extends StringIndexed {
  id: IdType;
}

export interface EntityDateInfo {
  createdAt: string;
  updatedAt: string;
  deletedAt: string | null;
}

export type GlossaryType = {
  id: IdType;
  name: string;
};

export interface RouteProps extends ReactRouterRouteProps {
  name: string;
  icon?: string;
  iconActive?: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  component: FC<any>;
  path: string;
  isDisabled: boolean;
}

export type MultipleIds = {
  ids: IdType[];
};

export type BaseMessageDto = {
  message: string;
};
export type BrandingLogoDto = {
  dashboardBrandingLogoFileId: number | null;
};

export type CheckboxGroupDataType = {
  id: IdType;
  checked: boolean;
};

export enum CommonAnswer {
  Yes = 'Yes',
  No = 'No',
}

export enum CommonPastAnswer {
  CURRENTLY = 'Yes, Currently',
  PAST = 'Yes, In the Past',
  NO = 'No',
}

export enum EventMode {
  CREATE = 'CREATE',
  UPDATE = 'UPDATE',
}

// Common Status to filter entities in lists and sagas.
export enum EntityStatus {
  CREATE = 'CREATE',
  UPDATE = 'UPDATE',
  DELETE = 'DELETE',
}

export enum SurgeryWhich {
  LEFT = 'One-Left',
  RIGHT = 'One-Right',
  BOTH = 'Both',
}

export enum ShowAllMyShared {
  All = 'all',
  My = 'my',
  Shared = 'shared',
}

export enum SortingBy {
  ASC = 'ASC',
  DESC = 'DESC',
}

export enum OrderBy {
  APPOINTMENT_DATE = 'appointmentDate',
  CREATION_DATE = 'creationDate',
  DATE_CREATED = 'dateCreated',
  DATE_DELETED = 'deletedDate',
  LAST_MODIFIED = 'last_modified',
  REGISTRATION_DATE = 'registrationDate',
  SUBMITTED_DATE = 'submittedDate',
  TITLE = 'title',
}

export enum Role {
  ADMIN,
  ORG_ADMIN,
  DOCTOR,
  PATIENT,
}

// In future replace to EntityStatus
export enum PatientRecordItemStatus {
  CREATE,
  UPDATE,
  DELETE,
}

export type OrNull<T> = { [K in keyof T]: T[K] | null };
